<template>
	<!-- <div>{{msg}}</div> -->
</template>

<script>
import DingtalkService from '@/api/dingtalk/DingtalkService.js'
import Vue from "vue";

export default {
  data() {
    return {
      msg:''
    }
  },
  mounted() {
    this.dingtalkLogin()
  },
  methods: {
    dingtalkLogin() {
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        let corpId = this.getQueryVariable('corpId')
        let businessId = this.getQueryVariable('businessId')
        let procInsId = this.getQueryVariable('procInsId')
        let service = "/" + this.getQueryVariable('service')//当前业务路径 /refund
        Vue.cookie.delete("pm-token")
        dd.runtime.permission.requestAuthCode({
          corpId: corpId,
          onSuccess: (result) => {
            new DingtalkService().materDingtalkLogin(result.code).then(({data}) => {
              Vue.cookie.set('pm-token', data.token);
              Vue.cookie.set('date', data.date);
              Vue.cookie.set('name', data.name);
              Vue.cookie.set('mater-userId', data.userId);
              this.$router.push({
                path: service,
                query: {
                  id: businessId,
                  procInsId: procInsId,
                }
              })
            }).catch(err=>{
              this.msg = "err2:"+JSON.stringify(err)
            })
          },
          onFail: (err) => {
            this.$message.error('err:' + JSON.stringify(err));
          }
        });

      });
    },
    getQueryVariable(variable) {
      var query = window.location.href.split("?")[1]
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    }
  }
}
</script>

<style>
</style>
